import type { Component } from 'svelte';
import Figure from '../../components/Figure.svelte';
import AccountProfileView from '../../components/CustomerPages/AccountProfileView.svelte';
import Designer from '../../components/Designer.svelte';
import TagCategory from '../../components/TagCategory.svelte';
import AccountProfileEdit from '../../components/CustomerPages/AccountProfileEdit.svelte';
import AccountShippingEdit from '../../components/CustomerPages/AccountShippingEdit.svelte';
import AccountOrdersView from '../../components/CustomerPages/AccountOrdersView.svelte';
import TaxCertificates from '../../components/CustomerPages/TaxCertificates.svelte';
import type { StickerShopMeta } from '$lib/types/StickerShopMeta';
import type { RequestContext } from '$lib/server/request-context';
import type { Market } from '$lib/i18n';

export type ExternalDataKey =
  | 'figure'
  | 'designer'
  | 'tag'
  | 'customer'
  | 'accountEdit'
  | 'accountShipping'
  | 'accountOrdersView'
  | 'taxCertificates';

export interface ExternalData {
  dataKey: ExternalDataKey;
  stickerShopMeta: StickerShopMeta;
  name: string;
  slug: string;
  market: Market;
}

export type ExternalDataArguments = RequestContext & {
  stickerShopMeta: StickerShopMeta;
};

export const getExternalDataComponent = (componentKey: ExternalDataKey) => {
  const component = externalComponentsMap[componentKey];

  if (!component) {
    console.error(`Component ${componentKey} is missing from externalComponentsMap.
  `);
  }

  return component;
};

// Svelte components that are used in the external data resolver, key should map to ExternalDataKey
const externalComponentsMap = {
  figure: Figure,
  designer: Designer,
  tag: TagCategory,
  customer: AccountProfileView,
  accountEdit: AccountProfileEdit,
  accountShipping: AccountShippingEdit,
  accountOrdersView: AccountOrdersView,
  taxCertificates: TaxCertificates,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} satisfies Record<ExternalDataKey, Component<any>>;
